import { CreditCardList } from '@/pages/creditCardList/CreditCardList';
import {
  SchedulingProps,
  SchedulingWarningsProps,
} from '../../SchedulingInterface';
import { CreditCardDTO } from '@/data/DTOs/schedule/CreditCardDTO';
import { useTranslation } from 'react-i18next';

export const ScheduleChooseCreditCardWrapper = ({
  changeInternalStep,
  setLoading,
  loading,
  setShowWarning,
  setWarningMessage,
  internalObject,
  setInternalObject,
  schedule,
  setSchedule,
}: SchedulingProps & SchedulingWarningsProps) => {
  const { t } = useTranslation(['schedule']);

  return (
    <CreditCardList
      selectedCreditCard={internalObject.creditCardDTO}
      setSelectedCreditCard={(creditCard: CreditCardDTO) => {
        setSchedule({ ...schedule, creditCardId: creditCard.creditCardId });
        setInternalObject({
          ...internalObject,
          creditCard: `${creditCard.banner} **** ${creditCard.lastDigits}`,
          paymentType: t('screen_choose_payment_card'),
          creditCardDTO: creditCard,
        });
      }}
      loading={loading}
      setLoading={setLoading}
      setShowWarning={setShowWarning}
      setWarningMessage={setWarningMessage}
      onChangeInternalStep={(change) => changeInternalStep(change)}
      appointmentTypeId={schedule.appointmentTypeId.toString()}
      locationId={schedule.locationId || ''}
    />
  );
};
